import React from "react";
import Newsletter from "./Newsletter";
import SocialMedia from "./SocialMedia";
import sitedata from "../sitedetails.json";

const Footer = () => {
  return (
    <div>
      <div className="bg-brand_jaguar h-full  w-full font-outfit text-white">
        <div className="grid grid-cols-2 lg:gap-20 py-8 font-outfit px-[10px] lg:px-[300px]  ">
          <div className="mx-auto text-sm ">
            {/* Services   */}
            <h1 className="font-semibold lg:text-xl  py-2">Our Services</h1>
            <ul className="list-disc  lg:text-lg">
              {sitedata.services.map((ser) => (
                <li key={ser} className="hover:text-brand_yellow">
                  {ser}
                </li>
              ))}
            </ul>
          </div>
          <div className="mx-auto text-sm">
            {/* Contact  */}
            <h1 className="font-semibold lg:text-xl py-2">Contact Us</h1>
            <ul className="list-disc lg:text-lg">
              <li className="hover:text-brand_yellow">
                {sitedata.contactdetails.phone}
              </li>
              <li className="hover:text-brand_yellow">
                {sitedata.contactdetails.address}
              </li>
              <li className="hover:text-brand_yellow">
                {sitedata.contactdetails.email}
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center">
          <Newsletter />
          <SocialMedia />
        </div>
      </div>
      <div className="bg-[#1C1C1C] px-16 lg:px-[300px] h-full w-full font-outfit text-white">
        <div className="flex justify-between py-2">
          <h1>{sitedata.brand_name}</h1>
          <h1 className="hidden md:block">Privacy</h1>
          <h1 className="hidden md:block">Terms & Conditions</h1>
          <h1>Copyright © 2023</h1>
        </div>
      </div>
    </div>
  );
};

export default Footer;
